<template>
    <div class="device-controls__block">
        <div class="device-controls__row device-controls__row--title">
            <span class="dci__title">
                <span class="sg-vrm-icon_113_inverter-24px"></span>
                {{ $t('dashboard.dci.inverter') }}
            </span>
        </div>
        <div
            class="sg-element dci__enable-message"
            @click="goToSettings"
            v-html="$t('dashboard.dci.activate_inverter')"
        ></div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularLocaleBundle } from '../../../../../../angular-bridge/modules/i18n';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component
@AngularLocaleBundle('dashboard')
export default class ActivateInvertersCard extends Vue {
    @ngInject()
    $state;

    get idSite() {
        return this.$route.params.id;
    }

    goToSettings(event) {
        if (event.target.id === 'settings') {
            this.$state.go('base.installation.settings.general', { id: this.idSite });
        }
        document.body.style.overflow = 'auto';
    }
}
</script>
